// src/oura/delivery/workModel.ts
//
// Small rules the Phase 3 parts share (WorkParts.tsx, the drawer and the
// Site screen's AI readers card), kept out of the component files.

import { isReadersItem, type DeliveryItem, type ReaderCheck } from "@service/aeo/delivery";
import { DELIVERY_WORK_ON } from "./workFlag";

/** A reader passes when robots.txt allows it, it got in, and the words show without scripts. */
export function readerPasses(r: ReaderCheck): boolean {
    return r.robotsAllows === true && r.gotIn === true && r.wordsVisible === true;
}

/**
 * Whether an item's pinned tick is really the AI reader test (H38): Test, not
 * a hand tick. A3's AI readers item, by its id as the Site card finds it,
 * tested or not: it closes on the test's proof, never by hand.
 */
export function isReaderTest(item: DeliveryItem | null | undefined): boolean {
    return DELIVERY_WORK_ON && isReadersItem(item);
}
